import api from "../../utilities/Interceptor";

const url = process.env.REACT_APP_API_KEY

interface Comment {
    date: Date;
    routeId: string;
    comments: string;
    name: string;
    client: any;
    email: string;
    employeeNumber: string
}

export const getRoutesByClient = (setRoutes: any, id: number) => {
    api.get<{ ID_RUTA: number, NOMBRE: string }>(`${url}/maps/routesByClient/${id}`).then((res) => {
            setRoutes(res.data);
        }
    ).catch((error) => {
        console.log("error", error);
    })
}

export const addComments = async (data:Comment) => {
    try {
        const response = await api.put(`${url}/maps/comments`, data);
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error("Ha ocurrido un error al intentar agregar su comentario. Por favor, inténtelo nuevamente más tarde.");
    }
}
